import React, { forwardRef } from 'react';

import Loading from '@/components/common/Loading';
import { t } from '@/utils/helper/intl';

export interface UploadForwardProps {
  text?: React.ReactNode;
  slotNode?: React.ReactNode;
}

const UploadForward = forwardRef<HTMLDivElement, UploadForwardProps>(
  (props, ref): React.ReactNode => {
    const { text, slotNode } = props || {};

    return (
      <div ref={ref} className={`wrapper-upload-forward relative w-full h-full `}>
        {slotNode ? (
          slotNode
        ) : (
          <Loading size={40} text={(text || t('merror.tip.pleaseWait')) as string} />
        )}
      </div>
    );
  },
);

export default UploadForward;
